export default __webpack_public_path__ + "static/media/5273.44f8dfb0.png";